var PidSolicitationMapper = /** @class */ (function () {
    function PidSolicitationMapper() {
    }
    PidSolicitationMapper.toDomain = function (data) {
        var _a, _b;
        var info = {
            name: data.nome,
            cpf: data.cpf,
        };
        var driverLicense = {
            renach: data.renach,
            register: data.registro,
            expirationDate: data.dataVencimento,
            validity: data.dataValidade,
        };
        var person = { info: info, driverLicense: driverLicense };
        var barCode = {
            code: data.codigoBarra,
            barCodeImage: data.codBarraImg,
        };
        var pix = {
            code: (_a = data === null || data === void 0 ? void 0 : data.chavePix) !== null && _a !== void 0 ? _a : "",
            pixImage: (_b = data === null || data === void 0 ? void 0 : data.qrCodePixBase64) !== null && _b !== void 0 ? _b : "",
        };
        var billet = {
            barCode: barCode,
            pix: pix,
            billetPdf: data.pdfB64,
            totalValue: data.valorPrinc,
        };
        var tax = { billet: billet };
        return {
            person: person,
            tax: tax,
            protocol: data.numeroProtocolo,
        };
    };
    return PidSolicitationMapper;
}());
export { PidSolicitationMapper };
